import { render } from "./GameOutputScreen.vue?vue&type=template&id=1ce7b4b4&scoped=true&lang=html"
import script from "./GameOutputScreen.vue?vue&type=script&lang=js"
export * from "./GameOutputScreen.vue?vue&type=script&lang=js"

import "./GameOutputScreen.vue?vue&type=style&index=0&id=1ce7b4b4&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/aethonspel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce7b4b4"]])

export default __exports__